import { render, staticRenderFns } from "./AccountHolderExpenseDenial.vue?vue&type=template&id=6144da06&scoped=true"
import script from "./AccountHolderExpenseDenial.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseDenial.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderExpenseDenial.vue?vue&type=style&index=0&id=6144da06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6144da06",
  null
  
)

export default component.exports